import React from "react";

const CardActionsLeft = ({ children }) => {
    return <div className="ActionsBar-left">{children}</div>;
};
export default CardActionsLeft;
